import { Button, Stack, Typography } from '@mui/material';
import i18n from 'i18next';

import appRoutes from 'app.routes';

interface IErrorBoundary {
  error: Error | unknown;
  componentStack: string | null;
  resetError: () => void;
}

const ErrorBoundary = (props: IErrorBoundary) => {
  const { error, componentStack, resetError } = props;
  return (
    <Stack display="flex" alignItems="center" justifyContent="center" flexDirection="column" sx={{ m: 10 }} gap={5}>
      <Typography color="error" variant="h4">
        {i18n.t('common.placeholders.errorBoundaryTitle')}
      </Typography>
      <Button href={appRoutes.dashboard()} variant="contained" onClick={resetError}>
        {i18n.t('common.actions.returnHome')}
      </Button>
      {process.env.NODE_ENV !== 'production' && componentStack && (
        <Stack gap={2}>
          <Typography color="error">Error:</Typography>
          <Typography variant="body2">{error?.toString()}</Typography>
          <Typography color="info">Component Stack:</Typography>
          <Typography variant="body2">{componentStack}</Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default ErrorBoundary;
